'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _getClient = require('../pubsub/selectors/getClient');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getIsClientReady = function getIsClientReady(client) {
  return client !== null && typeof client !== 'undefined';
};

var VisitorPubSubHandlerMiddleware = function VisitorPubSubHandlerMiddleware(handlers) {
  return function (store) {
    return function (next) {
      return function (action) {
        var client = (0, _getClient.getClient)(store.getState());

        if (action.type === ActionTypes.FORCE_CLIENT_OFFLINE && getIsClientReady(client)) {
          client.stop();
        }

        var handler = handlers[action.type];
        if (typeof handler === 'function' && getIsClientReady(client)) {
          handler(action, store.getState, store.dispatch, client);
        }

        return next(action);
      };
    };
  };
};

exports.default = VisitorPubSubHandlerMiddleware;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/middleware/VisitorPubSubHandlerMiddleware.js
// module id = 843
// module chunks = 2 3